//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {HeadBar, CellRow} from '@/components';
import utils from '@/utils/utils';
import {HotelProxy} from '@/http/RequestProxy.class.js';
import axios from 'axios';

const hotelProxy = new HotelProxy();
const EVAL_IMGS_ARR = new Array(5).fill('icon-stars-grey@2x.png');

export default {
  name: 'hotel-evaluation',
  components: {HeadBar},
  data(){
    return {
      hotelInfo: {},    // 酒店数据
      isShowOtherEval: false,   // 是否显示其他评价
      totalEvaluation: new Array(5).fill('star-lg-grey@2x.png'),  // 总体评价
      totalEvaluationStr: '',     // 总体评价文字说明
      evalLevelName: [this.$i18n.t('hotel.EVAL_GENERAL_LIST_1'), this.$i18n.t('hotel.EVAL_GENERAL_LIST_2'), this.$i18n.t('hotel.EVAL_GENERAL_LIST_3'), this.$i18n.t('hotel.EVAL_GENERAL_LIST_4'), this.$i18n.t('hotel.EVAL_GENERAL_LIST_5')], // ['差', '不好', '一般', '好', '非常好']
      otherEvaluations: [{
        name: this.$i18n.t('hotel.LOCATION'),
        type: 'rating_location',
        evalStr: '',
        evalImgs: Array.from(EVAL_IMGS_ARR),
      }, {
        name: this.$i18n.t('hotel.SERVICE'),
        type: 'rating_service',
        evalStr: '',
        evalImgs: Array.from(EVAL_IMGS_ARR),
      }, {
        name: this.$i18n.t('hotel.HEALTH'),
        type: 'rating_cleanliness',
        evalStr: '',
        evalImgs: Array.from(EVAL_IMGS_ARR),
      }, {
        name: this.$i18n.t('hotel.FACILITY'),
        type: 'rating_facility',
        evalStr: '',
        evalImgs: Array.from(EVAL_IMGS_ARR),
      }],

      params: {
        hotel_id: '',
        content: '',
        order_id: '',
        rating_overall: '',
        rating_service: '',
        rating_cleanliness: '',
        rating_location: '',
        rating_facility: '',
        media_list: [],
        is_anonymous: 0,    // 是否匿名评价
      },

      files: [],      // 选取的文件
      imgBase64: [],  // 图片的base64地址
    };
  },
  mounted(){
    const {query} = this.$route;

    this.hotelInfo = query;
    this.params.hotel_id = query.hotel_id;
  },
  methods: {
    /** 返回上一页 */
    onBack(){
      this.$router.back();
    },

    onSetAnonymous(){
      this.params.is_anonymous === 0 ? this.params.is_anonymous = 1 : this.params.is_anonymous = 0;
    },

    /** 总体评价 */
    onTotalEvaluation(curIndex){
      const greenStar = 'star-lg-green@2x.png',
            greyStar = 'star-lg-grey@2x.png';

      this.params.rating_overall = curIndex + 1;  // 记录当前总体评分
      this.isShowOtherEval = true;

      for(let i = 0, len = this.totalEvaluation.length; i < len; i++){
        if(i > +curIndex){
          this.$set(this.totalEvaluation, i, greyStar);
        }else{
          this.$set(this.totalEvaluation, i, greenStar);
        }
      }

      // 首次评价，默认评价所有项
      if(!this.totalEvaluationStr){
        for(let j = 0, otherLen = this.otherEvaluations.length; j < otherLen; j++){
          this.onSetOtherEval(j, curIndex);
        }
      }

      this.totalEvaluationStr = this.evalLevelName[curIndex];
    },

    /** 其他评价 */
    onSetOtherEval(evalIdx, imgIdx){
      const greyPath = 'icon-stars-grey@2x.png',
            greenPath = 'icon-stars-green@2x.png',
            evalObj = this.otherEvaluations[evalIdx],
            evalType = evalObj.type;

      this.params[evalType] = imgIdx + 1; // 保存当前评价项的评分
      evalObj.evalStr = this.evalLevelName[imgIdx];

      for(let i = 0, len = evalObj.evalImgs.length; i < len; i++){
        if(i > +imgIdx){
          evalObj.evalImgs[i] = greyPath;
        }else{
          evalObj.evalImgs[i] = greenPath;
        }
      }
    },

    onGetImgFile(ev){
      const that = this,
            files = Array.from(ev.target.files),
            fileLen = files.length,
            originLen = that.imgBase64.length;

      if(fileLen + originLen > 9){
        files.splice(9 - originLen);
        that.$vux.alert.show({
          content: that.$i18n.t('hotel.MAX_IMAGES_WITH_NINE'),
        });
      }

      files.forEach(item => {
        that.files.push(item);
        utils.imageCompressAndRotate(item, {
          success(base64){
            that.imgBase64.unshift(base64);
          },
        });
      });
    },

    onDelImg(fileIndex){
      this.files.splice(fileIndex, 1);
      this.imgBase64.splice(fileIndex, 1);
    },

    /** 获取图片上传相关数据 */
    getUploadKey(){
      const API_URL = process.env.APP_URL + 'oss-service/web/get.php';

      if(this._validateParams()){
        axios({
          url: API_URL,
          withCredentials: true,
        }).then(resp => {
          if(+resp.data.succeed === 1){
            this.imgUpload(resp.data.data);
          }else{
            const curLocal = encodeURIComponent(window.location.href);

            window.location.href = `${this.$store.state.WAP_HOST}login.php?redirect_url=${curLocal}`;
          }
        });
      }
    },

    /** 图片上传 */
    imgUpload(obj){
      const axiosQueue = [];

      this.files.forEach(file => {
        const formData = new FormData();

        formData.append('key', obj['dir'] + utils.randomString(10) + utils.getSuffix(file.name));
        formData.append('policy', obj['policy']);
        formData.append('OSSAccessKeyId', obj['accessid']);
        formData.append('success_action_status', '200');
        formData.append('callback', obj['callback']);
        formData.append('signature', obj['signature']);

        formData.append('file', file);
        formData.append('name', file.name);

        const axiosObj = axios({
          url: obj.host,
          method: 'post',
          withCredentials: false,
          headers: {'Content-Type': 'multipart/form-data'},
          data: formData,
        });

        axiosQueue.push(axiosObj);
      });

      this.$vux.loading.show();
      axios.all(axiosQueue)
        .then(resp => {
          resp.forEach(item => {
             this.params.media_list.push(item.data.ResourceId);
          });

          this.onSubmitEval();
        });
    },

    _validateParams(){
      if(!this.params.rating_overall){
        this.$vux.alert.show({
          content: this.$i18n.t('hotel.GRADE_EVAL'),
        });

        return false;
      }

      if(this.params.content.length <= 5 || this.params.content.length > 2000){
        this.$vux.toast.show(this.$i18n.t('hotel.LIMIT_COMMENT_TXT'));
        return false;
      }

      return true;
    },

    /** 提交评价数据 */
    onSubmitEval(){
      hotelProxy.submitEvaluation(this.params)
        .then(resp => {
          this.$vux.loading.hide();
          if(resp){
            this.$vux.toast.show(resp.msg);
            setTimeout(() => {
              // 跳转到评价列表页
              this.$router.push({name: 'evaluation-list', params: {hotel_id: this.params.hotel_id}})
            }, 1000);
          }
        });
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/evaluation/hotel-evaluation.vue